import { useTranslation } from 'react-i18next';
import { InfoHint } from '@/shared/components';
import LockIcon from '@/shared/assets/lock-icon.svg?react';

export const MfaAppDescription = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('authPages.identityConfirmationForm.appDescription')}
      <InfoHint
        title={t('authPages.identityConfirmationForm.appHint.title')}
        icon={<LockIcon />}
        className="ml-[0.8rem] align-middle">
        {t('authPages.identityConfirmationForm.appHint.description')}
      </InfoHint>
    </>
  );
};
